import cn from "classnames";
import { Link } from "react-router-dom";

export const A = ({ children, className, href = "#", ...args }) => {
  const classes = cn(
    "font-medium text-black-600 hover:text-blue-500 dark:text-white",
    className,
  );

  return (
    <Link href={href} className={classes} {...args}>
      {children}
    </Link>
  );
};
